import React from "react";

import { StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";
import Meta, { MetaInterface } from "../../../../componets/Meta";
import { ActiveTag, PublishedTag, StatusTag } from "./_Tags";
import IconText from "../../../../componets/IconText";
import { HeartOutlined, SwitcherOutlined } from "@ant-design/icons";
import StatsIcons from "../../../../componets/StatsIcons";

interface _MetaInterface {
  stickerPack: StickerPackInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  showStats?: boolean;
}

const _Meta = ({ stickerPack, shape, size, showStats }: _MetaInterface) => {
  let description: any = null;

  if (!stickerPack) {
    return null;
  }

  if (showStats) {
    description = (
      <div>
        <div className='v-sticker-pack-table-list--statuses'>
          <StatusTag key='tag-status' status={stickerPack.status} />
          <PublishedTag key='tag-published' published={stickerPack.published} />
          <ActiveTag key='tag-active' active={stickerPack.active} />
        </div>

        <StatsIcons
          icons={[
            <IconText tooltip='popular' icon={HeartOutlined} text={stickerPack?.popular_count} />,
            <IconText tooltip='stickers' icon={SwitcherOutlined} text={stickerPack?.stickers_count} />,
            <IconText tooltip='approved stickers' icon={SwitcherOutlined} text={stickerPack?.active_stickers_count} />
          ]}
        />
      </div>
    )
  }

  return (
    <Meta
      url={stickerPack.url}
      size={size}
      shape={shape}
      avatar={stickerPack.image_url}
      title={stickerPack.name}
      description={description}
    />
  );
}

export default _Meta;
